import { useContext, useState, useEffect, useCallback } from 'react';
import { Navigate } from 'react-router-dom';

import { AuthContext } from '../context/auth-context';
import { useUserData } from '../hooks/useUserData.ts';
import LoadingSpinner from './UIElements/LoadingSpinner';

function ProtectedRoute({
  element: Component,
  tags = undefined,
  allowWithoutAssessment = false,
  ...rest
}) {
  const auth = useContext(AuthContext);
  const { userData } = useUserData();
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);

  const validToken = useCallback(async () => {
    const now = new Date().getTime();
    const expiry = userData?.expiration && new Date(userData.expiration).getTime();
    if (!expiry) {
      return false;
    }
    if (now > expiry) {
      auth.logout();
      return false;
    }
    return true;
  }, [auth, userData?.expiration]);

  useEffect(() => {
    const checkToken = async () => {
      const valid = await validToken();
      setIsValid(valid);
      setIsLoading(false);
    };

    checkToken();
  }, [validToken]);

  if (isLoading) {
    return <LoadingSpinner asOverlay />;
  }

  // eslint-disable-next-line no-nested-ternary
  return isValid ? (
    tags === undefined || tags.length > 0 || allowWithoutAssessment ? (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <Component {...rest} />
    ) : (
      <Navigate to="/assessment" />
    )
  ) : (
    <Navigate to="/code" state={{ from: window.location.pathname }} />
  );
}

export default ProtectedRoute;
